import React, { Dispatch, useCallback } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Button, Icon } from 'vetrf-ui';
import { ExcelFields } from '../../types/api';
import { ActionKind, ExportAction } from './types';
import styles from './ExportExcelModal.module.scss';
import { DraggableItem } from './DraggableItem';

type ExportingFieldsProps = {
  dispatch: Dispatch<ExportAction>;
  excelItems: Record<string, ExcelFields[]>;
};

export const ExportingFields = ({ dispatch, excelItems }: ExportingFieldsProps) => {
  const onDragEnd = useCallback((result) => {
    const { destination, source } = result;
    if (result.reason === 'DROP') {
      if (!destination) {
        return;
      }
      dispatch({
        type: ActionKind.MOVE,
        source,
        destination,
      });
    }
  }, []);

  const handleRight = () => {
    dispatch({ type: ActionKind.RIGHT });
  };

  const handleLeft = () => {
    dispatch({ type: ActionKind.LEFT });
  };

  const emptyListPlaceholder = (right?: boolean) => (
    <div className={styles.emptyListPlaceholder}>
      <Icon icon={!right ? 'reply' : 'share'} size={170} />
      Перетащите сюда
    </div>
  );

  return (
    <div className="d-flex flex-column flex-sm-row align-items-stretch gap-15">
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="flex-1">
          <div className="panel-heading p-0 pb-5">
            <div className="d-flex justify-content-between align-items-center gap-5">
              <h5>Все доступные поля</h5>
              <Button
                icon="angle-double-right"
                iconColor="blue"
                iconSize={220}
                onlyIcon
                tooltip="Переместить все"
                onClick={handleRight}
              />
            </div>
          </div>
          <Droppable droppableId="items">
            {(provided) => (
              <div
                className={styles.listContainer}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {excelItems.items?.length
                  ? excelItems.items.map((item, index) => (
                      <DraggableItem key={item.field} item={item} index={index} />
                    ))
                  : emptyListPlaceholder()}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
        <div className="flex-1">
          <div className="panel-heading p-0 pb-5">
            <div className="d-flex justify-content-between align-items-center gap-5">
              <h5>Поля, экспортируемые в excel-отчет</h5>
              <Button
                icon="angle-double-left"
                iconColor="blue"
                iconSize={220}
                onlyIcon
                tooltip="Переместить все"
                onClick={handleLeft}
              />
            </div>
          </div>
          <Droppable droppableId="selectedItems">
            {(provided) => (
              <div
                className={styles.listContainer}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {excelItems.selectedItems?.length
                  ? excelItems.selectedItems.map((item, index) => (
                      <DraggableItem key={item.field} item={item} index={index} />
                    ))
                  : emptyListPlaceholder(true)}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
    </div>
  );
};
